import { FeatureFlagClient } from '@indeed/flex-feature-flags'

import config from 'syft-acp-core/config'
import { fetchEnabledFeatures } from 'syft-acp-core/components/FeatureFlaggingProvider/fetchEnabledFeatures'

// flex-core targets this flag by job, venue AND city — every server-side evaluation is
// `FeaturesService.context(job_id:, venue_id:, city_id:).on?('move_overbook_worker_to_parent')`
// (Bookings::MoveOverbookWorkerToParent, FillAutomation::ShiftOverbookJob) — not by admin
// user like most ACP-facing flags. The shared FeatureFlaggingProvider only ever sends the
// admin's user id as the GrowthBook entity, so it can't reproduce that targeting.
//
// Fetched standalone here, scoped to a `job` entity: ActorAttributesResolver#job_attributes
// resolves all three ids server-side from this one job id, so a rule targeting any of them
// is honoured and ACP can't disagree with flex-core when targeting changes without an ACP
// deploy (STSMPD-2092).
export const MOVE_OVERBOOK_WORKER_TO_PARENT_FLAG = 'move_overbook_worker_to_parent'

export const fetchMoveOverbookWorkerToParentFlag = async jobId => {
  if (!jobId) {
    return false
  }

  const client = new FeatureFlagClient({
    apiBaseUrl: config.apiConfig.apiBaseUrl.replace(/\/?$/, ''),
    fetch: fetchEnabledFeatures,
    trackExposure: () => {},
    features: [MOVE_OVERBOOK_WORKER_TO_PARENT_FLAG],
    entity: { type: 'job', id: jobId },
  })

  await client.request()

  return client.isFeatureEnabled(MOVE_OVERBOOK_WORKER_TO_PARENT_FLAG)
}
